var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function (theme) { return ({
    components: {
        MuiOutlinedInput: {
            defaultProps: {
                notched: false,
                size: 'small',
            },
            styleOverrides: {
                root: {
                    backgroundColor: designTokens.color.shade.white.value,
                    borderRadius: theme.spacing(0.5),
                    '& > fieldset.MuiOutlinedInput-notchedOutline': {
                        borderColor: designTokens.color.gray.limestone.value,
                    },
                    ':hover': {
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.gray.limestone.value,
                        },
                    },
                    '&.Mui-error': {
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.status.error.value,
                        },
                        '&.Mui-focused': {
                            '& > fieldset.MuiOutlinedInput-notchedOutline': {
                                borderColor: designTokens.color.status.error.value,
                            },
                        },
                    },
                    '&.Mui-focused': {
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.secondary.default.value,
                            borderWidth: theme.spacing(0.125),
                        },
                    },
                    '&.Mui-disabled': {
                        backgroundColor: designTokens.color.gray.light.value,
                        '& > fieldset.MuiOutlinedInput-notchedOutline': {
                            borderColor: designTokens.color.gray.disabled.value,
                        },
                    },
                },
                input: __assign(__assign({}, muiTypography.uiTextSmall), { padding: theme.spacing(1, 1.5), boxSizing: 'border-box', minHeight: '40px', '::placeholder': {
                        color: designTokens.color.gray.disabled.value,
                        opacity: 1,
                    }, '&.Mui-disabled': {
                        '::placeholder': {
                            webkitTextFillColor: designTokens.color.gray.disabled.value,
                        },
                    } }),
                multiline: {
                    padding: 0,
                    '& .MuiInputBase-inputMultiline': __assign(__assign({}, muiTypography.paragraphSmall), { alignContent: 'flex-start', minHeight: 'unset', padding: '10px 12px 9px' }),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=outlinedInputTheme.js.map